import { render, staticRenderFns } from "./StaticPage.vue?vue&type=template&id=db98690e"
import script from "./StaticPage.vue?vue&type=script&lang=js"
export * from "./StaticPage.vue?vue&type=script&lang=js"
import style0 from "./StaticPage.vue?vue&type=style&index=0&id=db98690e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports